import Link from 'next/link';
import { useRef, useState, useCallback } from 'react';
import { IProductObject } from '@features/categories/typescript';
import styles from '@components/ProductCardNew/ProductCard.styles';
import getProductUrl from '@utils/getProductUrl';
import ProductImage from '@components/ProductCardNew/ProductImage/ProductImage';
import Promolabels from '@components/ProductCardNew/PromoLabels/PromoLabels';
import ProductCardDescription from '@components/ProductCardNew/ProductCardDescription/ProductCardDescription';
import { useOffer } from '@hooks/useOffer';
import 'react-loading-skeleton/dist/skeleton.css';
type PropsType = {
  product: IProductObject;
  selectFunction?: () => void;
  fromModal?: boolean;
  isSmall?: boolean;
  transparent?: boolean;
  searchUrl?: string;
  searchHightlight?: JSX.Element;
  onAuxClick?: (e: React.MouseEvent) => void;
  isSlider?: boolean;
  isSearch?: boolean;
  isWhiteBg?: boolean;
};
const ProductCard = ({
  product,
  selectFunction = () => null,
  fromModal = false,
  isSmall = false,
  transparent = false,
  isSlider = false,
  searchUrl = '',
  searchHightlight = undefined,
  onAuxClick = () => null,
  isSearch = false,
  isWhiteBg = false
}: PropsType) => {
  const {
    id,
    name,
    uuid,
    packshots,
    configurable,
    getPromoPercent,
    getPrice,
    getOmnibusPrice,
    getPromoPrice,
    checkFlagActive,
    getFromFlag,
    swatches,
    colorsCount,
    priceUnit,
    gpsr
  } = product;
  const [isLoading, setIsLoading] = useState(true);
  const [isCardHovered, setIsCardHovered] = useState(false);
  const imageLinkRef = useRef<HTMLAnchorElement>(null);
  const [_, priceListName] = useOffer();
  const buildUrl = () => {
    if (searchUrl) return searchUrl;
    const base = getProductUrl(name, id);
    if (uuid !== undefined) {
      return `${base}?objectUuid=${uuid}`;
    }
    return base;
  };
  const handleClick = useCallback(() => {
    if (selectFunction) selectFunction();
  }, [selectFunction]);
  const productUrl = buildUrl();
  const hasHoverImage = (packshots?.hover?.length ?? 0) > 0 || (packshots?.hoverVideo?.length ?? 0) > 0 || (packshots?.hoverOpened?.length ?? 0) > 0;
  return <article data-testid="ListingProductCard" sx={styles.productCard(isSlider)} className={[fromModal ? 'product_from_photo' : '', hasHoverImage ? 'product-card-has-hover' : ''].filter(Boolean).join(' ')}>
      {/* biome-ignore lint/a11y/noStaticElementInteractions: tylko hover wizualny (np. PromoLabels); wejście w produkt nadal przez Link */}
      <div role="presentation" sx={styles.productCardInner(isSlider)} onMouseEnter={() => setIsCardHovered(true)} onMouseLeave={() => setIsCardHovered(false)} data-testid="product-card-inner">
        <div sx={styles.visualArea(transparent, isWhiteBg)} title={name || ''}>
          <Link href={productUrl} ref={imageLinkRef} onClick={handleClick} onAuxClick={onAuxClick} aria-label={name} sx={styles.imageLink} tabIndex={0} data-testid="product-card-image-link">
            <ProductImage packshots={packshots} alt={name || ''} setIsLoading={setIsLoading} isSmall={isSmall} isSlider={isSlider} isSearch={isSearch} data-testid="product-card-image" />
          </Link>
          <Promolabels configurable={configurable} productUrl={productUrl} onConfigClick={handleClick} pricePromoPercent={getPromoPercent(priceListName)} checkFlagActive={checkFlagActive} isSmall={isSmall} transparent={transparent} hasHoverImage={hasHoverImage} isCardHovered={isCardHovered} />
        </div>
        <ProductCardDescription name={name} searchHightlight={searchHightlight} price={getPrice(priceListName)} priceUnit={priceUnit} promoPrice={getPromoPrice(priceListName)} omnibusPrice={getOmnibusPrice(priceListName)} showFrom={getFromFlag(priceListName)} swatches={swatches} totalColorsCount={colorsCount} isSmall={isSmall} isSlider={isSlider} isLoading={isLoading} gpsr={gpsr} productUrl={productUrl} onLinkClick={handleClick} onAuxClick={onAuxClick} />
      </div>
    </article>;
};
export default ProductCard;